import React, { useState } from "react";
import FormStaff from "./FormStaff";
import ModalContainer from "../containers/ModalContainer";

const ModalTambahStaf = ({ create, staf, toggle, isOpen }) => {
  const [title] = useState(create ? "Form Staf" : "Update Staf");

  return (
    <ModalContainer
      title={title}
      isOpen={isOpen}
      toggle={toggle}
    >
      <FormStaff toggle={toggle} data={staf} isOpen={isOpen} />
    </ModalContainer>
  );
};

export default ModalTambahStaf;
